var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgUnion = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      cursor: "pointer"
    },
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.72855 0.978553C7.92382 0.783291 7.92382 0.466709 7.72855 0.271447C7.53329 0.0761845 7.21671 0.0761845 7.02145 0.271447L4 3.29289L0.978553 0.271447C0.783291 0.0761845 0.466709 0.0761845 0.271447 0.271447C0.0761845 0.466709 0.0761845 0.783291 0.271447 0.978553L3.29289 4L0.271447 7.02145C0.0761845 7.21671 0.0761845 7.53329 0.271447 7.72855C0.466709 7.92382 0.783291 7.92382 0.978553 7.72855L4 4.70711L7.02145 7.72855C7.21671 7.92382 7.53329 7.92382 7.72855 7.72855C7.92382 7.53329 7.92382 7.21671 7.72855 7.02145L4.70711 4L7.72855 0.978553Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUnion, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Union.e362b598.svg";
export { ForwardRef as ReactComponent };